import ReportPage from "components/Reports/Pages/SingleReport";

function ClinicReport() {
    return (
        <>
            <ReportPage isStandalone={false} />
        </>
    )
}

export default ClinicReport;
